import BaseModule from './BaseModule.js'

class AuthManager extends BaseModule {
  constructor() {
    super()
  }

  login(data) {
    return this.post('/api/auth/login', data).then(result => result.data)
  }

  logout(token) {
    return this.post('/api/auth/logout', { token }).then(result => result.data)
  }

  wx(){
    return this.get('/api/auth/wx').then(result => result.data)
  }

  wxLogin(code){
    return this.post('/api/auth/wx-login', { code }).then(result => result.data)
  }

  //验证码登录
  codeLogin(data){
    return this.post('/api/auth/code-login', data ).then(result => result.data)
  }

  bind(data){
    return this.post('/api/auth/bind', data).then(result => result.data)
  }

  isLogin(token){
    return this.get('/api/auth/is-login', {
      params : {
        token
      }
    }).then(result => result.data)
  }

  getDdParams() {
    return this.get('/api/auth/dd-info').then(result => result.data)
  }
}

export default new AuthManager()



// WEBPACK FOOTER //
// ./src/api/AuthManager.js